import {createType, createAction} from 'store/utils';

const prefix = 'DAILY_BUDGET';

export const UPDATE_DAILY_BUDGET = createType(prefix, 'UPDATE');
export const updateDailyBudget = (payload: DailyBudgetState): Action =>
  createAction(UPDATE_DAILY_BUDGET, payload);
